export enum MessageSenders {
  AGENT = 'agent',
  USER = 'user',
  CHATBOT = 'chatbot',
}
